// extracted by mini-css-extract-plugin
export var standaloneTable = "_f0-0";
export var standaloneTableWithBodyFill = "_f0-1";
export var withExtraHeader = "_f0-2";